import React, { Component, createRef } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import cookie from 'react-cookies';
import {
  Paragraph,
  Section,
  Button,
  Heading,
  SectionHeader,
  Link,
} from 'components';
import { generateHash, serialize } from '../../utils';

import './ContactFormFullwidth.scss';

class ContactFormFullwidth extends Component {
  constructor(props) {
    super(props);
    this.state = { _replyto: '' };

    this.refForm = createRef();
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleSubmit = e => {
    e.preventDefault();

    const form = this.refForm.current;
    const userId = '?visitor_id=' + cookie.load('visitor_id688533');
    const { pardotLink } = this.props;
    const url = pardotLink.concat(userId);
    const connectionId = generateHash();

    fetch(url, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'application/json',
      },
      body: serialize(form),
    })
      .then(() => {
        if (typeof window !== 'undefined' && window.location) {
          window.location.href = `?thank-you&connectionId=${connectionId}`;
        }
        form.reset();
      })
      .catch(error => console.log(error));
  };

  render() {
    const { name, description, id, designMail } = this.props;

    const { _replyto } = this.state;

    return (
      <Section id={id} color={'yellow'}>
        <Row className={'no-gap'}>
          <Col sm={12} md={6}>
            <SectionHeader size={'big'} lineColor={'white'} fixed>
              {"Let's talk"}
            </SectionHeader>
          </Col>
          <Col sm={12} md={6}>
            <Heading
              size={'medium-plus'}
              additionalClass={'contact-form-fullwidth__description'}
            >
              {description}
            </Heading>
          </Col>
        </Row>
        <Row className={'contact-form-fullwidth__row no-gap'}>
          <Col
            sm={12}
            md={6}
            className={'contact-form-fullwidth__contact-data'}
          >
            <Paragraph
              color={'black'}
              size={'medium'}
              additionalClass={'contact-form-fullwidth__phone'}
            >
              Phone:
            </Paragraph>
            <Link to={'tel:+48327390900'}>
              <Paragraph size={'medium-plus'} additionalClass={'text--bold'}>
                +48 32 739 09 00
              </Paragraph>
            </Link>

            <Paragraph
              color={'black'}
              size={'medium'}
              additionalClass={'contact-form-fullwidth__email'}
            >
              Got a digital product to discuss?
            </Paragraph>
            {designMail ? (
              <Link
                to={'mailto:design@boldare.com?subject=Why design matters?'}
                additionalClass={'design-mail'}
                id={'contact-form-fullwidth-design-boldare'}
              >
                <Paragraph size={'medium-plus'} additionalClass={'text--bold'}>
                  design@boldare.com
                </Paragraph>
              </Link>
            ) : (
              <Link
                to={'mailto:hello@boldare.com'}
                additionalClass={'contact-mail'}
                id={'contact-form-fullwidth-hello-boldare'}
              >
                <Paragraph size={'medium-plus'} additionalClass={'text--bold'}>
                  hello@boldare.com
                </Paragraph>
              </Link>
            )}

            <Paragraph
              color={'black'}
              size={'medium'}
              additionalClass={'contact-form-fullwidth__email'}
            >
              Would you like to join our crew?
            </Paragraph>
            <Link
              to={'mailto:career@boldare.com'}
              additionalClass={'career-mail'}
              id={'contact-form-fullwidth-career-boldare'}
            >
              <Paragraph size={'medium-plus'} additionalClass={'text--bold'}>
                career@boldare.com
              </Paragraph>
            </Link>
          </Col>
          <Col sm={12} md={6}>
            {typeof window !== 'undefined' &&
            window.location.href &&
            window.location.href.includes('?thank-you') ? (
              <Paragraph size={'medium'}>
                Message has been sent, thanks.
              </Paragraph>
            ) : (
              <form
                ref={this.refForm}
                name={name}
                className={'contact-form-fullwidth'}
                method="post"
                onSubmit={this.handleSubmit}
              >
                <input
                  type={'text'}
                  name={'_gotcha'}
                  style={{ display: 'none' }}
                />
                <input
                  type={'hidden'}
                  name={'_subject'}
                  value={`Boldare.com from ${_replyto} via ${typeof window !==
                    'undefined' && window.location}`}
                />
                <div className={'contact-form-fullwidth__personal-data'}>
                  <input
                    type={'text'}
                    name={'name'}
                    placeholder={'Name'}
                    onChange={this.handleChange}
                    required
                  />
                  <input
                    type={'email'}
                    name={'_replyto'}
                    placeholder={'E-mail'}
                    onChange={this.handleChange}
                    required
                  />
                </div>
                <textarea
                  name={'message'}
                  placeholder={'How can we help you?'}
                  onChange={this.handleChange}
                  required
                />
                <Button
                  id={`contact-form-fullwidth-${name}-submit`}
                  additionalClass={'boldare-contact-form'}
                  type={'submit'}
                  value={'submit'}
                  color={'yellow'}
                >
                  Send message
                </Button>
              </form>
            )}
          </Col>
        </Row>
      </Section>
    );
  }
}

ContactFormFullwidth.defaultProps = {
  description:
    'Do you want to build a product, hire a development team or simply have a question? Leave us a message.',
  pardotLink: 'https://go.boldare.com/l/688533/2019-02-28/x5r',
};

export default ContactFormFullwidth;
